import { firebaseStageCredentials } from '../secrets/firebase-stage';
import { AD_MOB_APP_ID, CHAT_TOKEN_STAGE, MAP_API_KEY, MAPBOX_TOKEN } from '../secrets/api-keys';

const DOMAIN = 'app.staging.orlikfy.pl';
const PACKAGE_NAME = 'com.orlikfy.stage';

export const environment = {
  environment: 'stage',
  production: false,
  apiUrl: 'https://vps-dcf4a9f9.vps.ovh.net',
  frontendUrl: `https://${DOMAIN}`,
  customUrl: `orlikfy://${DOMAIN}`,
  domain: DOMAIN,
  androidApkUrl: 'https://storage.googleapis.com/orlikfy-infra-stage.appspot.com/android-apk/app-release.apk',
  iOSApkUrl: '',
  firebase: firebaseStageCredentials,
  mapApiKey: MAP_API_KEY,
  mapboxToken: MAPBOX_TOKEN,
  chatToken: CHAT_TOKEN_STAGE,
  adMobAppId: AD_MOB_APP_ID,
  packageName: PACKAGE_NAME,
  appsFlyerDevKey: '',
  appsFlyerOneLinkDomain: '',
  appsFlyerOneLinkTemplateId: '',
  appId: '',
  facebookAppId: ''
};
